const {  registerVueComponent } = require("../vvuejs/vueRegister.mjs");

import FNotificationJS from './components/FNotificationJS.vue'
registerVueComponent('vnotification:js', 'FNotificationJS', FNotificationJS)

import FNotificationPhp from './components/FNotificationPhp.vue'
registerVueComponent('vnotification:php', 'FNotificationPhp', FNotificationPhp)

import FNotificationLabel from './components/FNotificationLabel.vue'
registerVueComponent('vnotification:label_notification', 'FNotificationLabel', FNotificationLabel)

import FNotificationLabelHtml from './components/FNotificationLabelHtml.vue'
registerVueComponent('vnotification:label_notification_html', 'FNotificationLabelHtml', FNotificationLabelHtml)

import FInvalidSession from './components/FInvalidSession.vue'
registerVueComponent('vnotification:invalid_session', 'FInvalidSession', FInvalidSession)